import { Component, Input, OnChanges } from '@angular/core';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';

@Component({
  selector: 'np-table-funnel-opportunity',
  templateUrl: './funnel-opportunity.component.html',
  styleUrls: ['./funnel-opportunity.component.scss']
})
export class TableFunnelOpportunityComponent implements OnChanges {
  @Input() type = '';

  public rows: Array<any> = [];
  public columns = [
      {
        title: 'Client Name',
        name: 'clientName',
        width: '150px'
      },
      {
        title: 'Sales Person/BDM/RM',
        name: 'salesPerson',
        width: '200px'
      },
      {
        title: 'Date Referred',
        name: 'dateReferred',
        sort: 'desc',
        type: TableCellTypes.Date,
        width: '150px'
      },
      {
        title: 'Stage in Sales Process',
        name: 'stageInSalesProcess',
        width: '150px'
      },
      {
        title: 'Next trade date',
        name: 'nextTradeDate',
        type: TableCellTypes.Date,
        width: '150px'
      },
      {
        title: 'Expected Transaction size',
        name: 'expectedTransactionSize',
        width: '170px'
      }
    ];

  constructor(private tableService: TableService) { }

  ngOnChanges() {
    if (!this.type) {
      return;
    }
    this.getTableData();
  }

  public getTableData() {
    const tableData = {
      getAll: true,
      sortType: 1,
      type: this.type
    };

    this.tableService.getTableMonthlyData(tableData).subscribe(
      data => {
        this.rows = data || [];
      },
    );
  }
}
